import { useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { resetPassword } from '../../services/AuthService';

function ResetPassword() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);
    const token = searchParams.get('token');

    useEffect(() => {
        if (!token) {
            setError('Token inválido ou ausente');
        }
    }, [token]);

    function onChangeInput(event) {
        if (event.target.id === 'password') {
            setPassword(event.target.value);
        } else {
            setConfirmPassword(event.target.value);
        }
        setError('');
    }

    function onSubmit(event) {
        event.preventDefault();
        setError('');

        if (!token) {
            setError('Token inválido ou ausente');
            return;
        }

        if (password.length < 6) {
            setError('A senha deve ter pelo menos 6 caracteres');
            return;
        }

        if (password !== confirmPassword) {
            setError('As senhas não coincidem');
            return;
        }

        setLoading(true);

        resetPassword(token, password)
            .then(() => {
                setSuccess(true);
                setLoading(false);
                setTimeout(() => {
                    navigate('/');
                }, 3000);
            })
            .catch(err => {
                console.error(err);
                setError(err.response?.data || 'Erro ao redefinir senha. O token pode ter expirado.');
                setLoading(false);
            })
    }

    return (
        <main>
            <section className="vh-lg-100 mt-5 mt-lg-0 bg-soft d-flex align-items-center">
                <div className="container">
                    <p className="text-center">
                        <Link to="/" className="d-flex align-items-center justify-content-center">
                            <svg className="icon icon-xs me-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z" clipRule="evenodd"></path>
                            </svg>
                            Voltar para o login
                        </Link>
                    </p>
                    <div className="col-12 d-flex align-items-center justify-content-center">
                        <div className="bg-white shadow border-0 rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                            <div className="text-center">
                                <img src="/img/favicon/mstile-150x150.png" alt="Beholder" width={64} />
                            </div>
                            <div className="text-center text-md-center mb-4 mt-md-0">
                                <h1 className="mb-0 h3">Redefinir senha</h1>
                            </div>
                            {success ? (
                                <div className="mt-4">
                                    <div className="alert alert-success">
                                        <p className="mb-0">
                                            <strong>Senha redefinida com sucesso!</strong>
                                        </p>
                                        <p className="mb-0 mt-2">
                                            Você será redirecionado para a página de login em alguns segundos.
                                        </p>
                                    </div>
                                    <div className="d-grid mt-4">
                                        <Link to="/" className="btn btn-gray-800">Ir para o login</Link>
                                    </div>
                                </div>
                            ) : (
                                <form action="#" className="mt-4" onSubmit={onSubmit}>
                                    <div className="form-group mb-4">
                                        <label htmlFor="password">Nova senha</label>
                                        <div className="input-group">
                                            <span className="input-group-text" id="basic-addon2">
                                                <svg className="icon icon-xs text-gray-600" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                                    <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd"></path>
                                                </svg>
                                            </span>
                                            <input 
                                                type="password" 
                                                placeholder="Nova senha" 
                                                className="form-control" 
                                                id="password" 
                                                required 
                                                onChange={onChangeInput}
                                                value={password}
                                                disabled={loading || !token}
                                                minLength={6}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group mb-4">
                                        <label htmlFor="confirmPassword">Confirmar nova senha</label>
                                        <div className="input-group">
                                            <span className="input-group-text" id="basic-addon3">
                                                <svg className="icon icon-xs text-gray-600" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                                    <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd"></path>
                                                </svg>
                                            </span>
                                            <input 
                                                type="password" 
                                                placeholder="Confirmar nova senha" 
                                                className="form-control" 
                                                id="confirmPassword" 
                                                required 
                                                onChange={onChangeInput}
                                                value={confirmPassword}
                                                disabled={loading || !token}
                                                minLength={6}
                                            />
                                        </div>
                                    </div>
                                    <div className="d-grid">
                                        <button 
                                            type="submit" 
                                            className="btn btn-gray-800" 
                                            disabled={loading || !token}
                                        >
                                            {loading ? 'Redefinindo...' : 'Redefinir senha'}
                                        </button>
                                    </div>
                                    {error && (
                                        <div className="alert alert-danger mt-2">{error}</div>
                                    )}
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
}

export default ResetPassword;



